import { PopoverPosition } from "@mandae/ng-popover";

/* globals angular, $, _ */
(function () {
  "use strict";

  function ImportSalesCtrl(
    $scope,
    $document,
    $stateParams,
    $mdPanel,
    $mdSidenav,
    $mdToast,
    $mdDialog,
    moment,
    IntegrationService,
    localStorageService,
    PackageParser,
    Pedido,
    PROVIDERS
  ) {
    var ctrl = this;
    var isMultipleChecked = false;
    var user = localStorageService.get("user");
    ctrl.orderColumnDestinatario = "asc";
    ctrl.toggleFilterOnlyMandaeShipping = false;
    ctrl.provider = IntegrationService.getProvider($stateParams.provider);

    ctrl.$onInit = function () {
      ctrl.disableOkBtn = true;
      ctrl.disableCreateBtn = true;
      ctrl.isCreatingOrders = false;
    };

    ctrl.maxDate = new Date();
    ctrl.startDate = moment();
    ctrl.endDate = moment();
    ctrl.sales = [];
    ctrl.salesOriginal = [];

    ctrl.datepicker = {};
    ctrl.datepicker.date = {
      startDate: ctrl.startDate,
      endDate: ctrl.endDate,
    };
    ctrl.datepicker.options = {
      autoApply: true,
      locale: {
        applyLabel: "OK",
        cancelLabel: "Cancelar",
        format: "DD/MM/YYYY",
        toLabel: "De",
        fromLabel: "Para",
        customRangeLabel: "Selecione intervalo",
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      },
      ranges: {
        Hoje: [moment(), moment()],
        Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Esta semana": [moment().startOf("week"), moment()],
        "Este mês": [moment().startOf("month"), moment().endOf("month")],
      },
      eventHandlers: {
        "apply.daterangepicker": function (evt) {
          ctrl.startDate = evt.model.startDate;
          ctrl.endDate = evt.model.endDate;
        },
      },
    };

    ctrl.selected = [];
    ctrl.tableOtps = {
      rowSelection: true,
      multiSelect: true,
      autoSelect: true,
    };

    function getStatuses() {
      var status;
      var localStatus = localStorage.getItem("filterStatus");
      if (localStatus) {
        status = JSON.parse(localStatus);
      } else {
        status = [];
        status.push(
          {
            name: "NOVO",
            displayName: "Novo",
            isChecked: true,
            code: 0,
          },
          {
            name: "EM_ANDAMENTO",
            displayName: "Coleta em rascunho",
            code: 1,
          },
          {
            name: "IMPORTADO",
            displayName: "Coleta solicitada",
            isChecked: true,
            code: 2,
          }
        );
        localStorage.setItem("filterStatus", JSON.stringify(status));
      }
      return status;
    }

    function setStatuses(statuses) {
      localStorage.setItem("filterStatus", JSON.stringify(statuses));
    }

    var statuses = getStatuses();

    ctrl.getStatusAttr = function (status, attr) {
      var obj = _.find(statuses, { name: status });
      return obj[attr];
    };

    function getStatusName() {
      return _.map(_.filter(statuses, { isChecked: true }), "name").join(",");
    }

    function addInitTracking() {

    }

    var addInitTrackingOnce = _.once(addInitTracking);

    function setBackdropHeight() {
      var height = $document.height();
      angular
        .element(".md-panel-outer-wrapper.md-panel-is-showing")
        .css("height", height);
    }

    ctrl.refreshSales = function () {
      ctrl.selected.length = 0;
      ctrl.getSales();
    };

    var shippingCode;
    ctrl.getSales = function (page) {
      var nextPage = 0;
      var mergeSales = false;
      var dateStart = new Date();
      if (page) {
        nextPage = page;
        mergeSales = true;
        ctrl.showBtnLoading = true;
      } else {
        ctrl.isLoading = true;
      }

      const startDate = moment(ctrl.startDate)
        .add(ctrl.startDate.utcOffset(), "minutes")
        .toISOString();
      const finalDate = moment(ctrl.endDate)
        .add(ctrl.endDate.utcOffset(), "minutes")
        .toISOString();

      IntegrationService.getSales(ctrl.provider.slug, {
        startDate,
        finalDate,
        status: getStatusName(),

        pagina: nextPage ? nextPage : 1,
      })
        .then(function (data) {
          addInitTrackingOnce();
          ctrl.isLoading = false;
          ctrl.showBtnLoading = false;
          ctrl.erros = data.erros;
          ctrl.total = data.totalVendas;
          ctrl.pagina = data.pagina;
          ctrl.paginas = data.paginas;
          ctrl.sales = mergeSales
            ? ctrl.sales.concat(data.vendas)
            : data.vendas;

          ctrl.sales.map((venda) => {
            venda.inputMvReadonly = false;
            venda.quantidadeVolumes = 1;
          });

          ctrl.salesOriginal = ctrl.sales;
        })
        .catch(function (err) {
          ctrl.isLoading = false;
          ctrl.showBtnLoading = false;
          ctrl.errorMessage = err.data && err.data.error.message;
        });
    };

    ctrl.ordenarEncomendas = function (type) {
      var order = {
        first: 1,
        second: -1,
      };

      if (type === "desc") {
        order = {
          first: -1,
          second: 1,
        };
      }

      ctrl.sales.sort((a, b) =>
        a.destinatario.nome > b.destinatario.nome ? order.first : order.second
      );

      ctrl.orderColumnDestinatario = type;
    };

    function showConfirm() {
      var confirm = $mdDialog
        .confirm()
        .title("Deseja realmente prosseguir?")
        .textContent("Ao prosseguir, as edições serão perdidas")
        .ok("OK")
        .cancel("cancelar");

      return $mdDialog.show(confirm);
    }

    function showSuccessToast() {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(
            "Sucesso! " +
              ctrl.selected.length +
              " encomendas adicionadas à sua coleta."
          )
          .position("bottom left")
      );
    }

    function showErrorToast() {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(
            "Encontramos algumas pendências. Corrija tudo e tente de novo!"
          )
          .action("x")
          .hideDelay(false)
          .position("top right")
      );
    }

    var errorsMap = {
      "destinatario.endereco.bairro": {
        name: "Bairro",
        group: "address",
      },
      "destinatario.endereco.cep": {
        name: "CEP",
        group: "address",
      },
      "destinatario.endereco.cidade": {
        name: "Cidade",
        group: "address",
      },
      "destinatario.endereco.estado": {
        name: "Estado",
        group: "address",
      },
      "destinatario.endereco.logradouro": {
        name: "Endereço",
        group: "address",
      },
      "destinatario.endereco.numero": {
        name: "Número",
        group: "address",
      },
      "formaEnvio.codigo": {
        name: "Serviço de envio",
        group: "delivery",
      },
      "formaEnvio.valorDeclarado": {
        name: "Seguro contra extravio",
        group: "delivery",
      },
      "formaEnvio.codigoRastreamento": {
        name: "",
        group: "delivery",
      },
      tipoDocumentoOrigem: {
        name: "",
        group: "delivery",
      },
      "destinatario.nome": {
        name: "Nome",
        group: "receiver",
      },
      "destinatario.email": {
        name: "E-mail",
        group: "receiver",
      },
      "destinatario.cnpj": {
        name: "CNPJ",
        group: "receiver",
      },
      "destinatario.cpf": {
        name: "CPF",
        group: "receiver",
      },
      chaveAcessoNfe: {
        name: "Chafe de Acesso NFe",
        group: "delivery",
      },
    };

    function getErrorsByGroup(errorsObj, errorGroup) {
      return _.filter(errorsObj, function (o) {
        return o.group === errorGroup;
      });
    }

    function getValidationErrors(errorsObj) {
      var newErrorsObj = {};
      _.forEach(errorsObj, function (err, k) {
        newErrorsObj[k] = angular.copy(errorsMap[k]);
        if (!newErrorsObj[k]) {
          console.log("Chave não encontrada:", k);
          return;
        }
        newErrorsObj[k].value = err;
      });
      return newErrorsObj;
    }

    function validate(orders, origin) {
      var sales = _.isArray(orders) ? orders : [orders];
      _.forEach(sales, function (o) {
        o.showSpinner = true;
        delete o.errors;
        delete o.addressErrors;
        delete o.receiverErrors;
        delete o.deliveryErrors;
      });
      ctrl.disableCreateBtn = true;
      IntegrationService.validate(sales)
        .then(function (data) {
          ctrl.disableCreateBtn = false;
          _.forEach(sales, function (sale) {
            var errorsObj = _.find(data.validacoes, {
              idImportacao: sale.idImportacao,
            }).erros;
            sale.showSpinner = false;
            if (_.isEmpty(errorsObj)) {
              sale.showOkIcon = true;
              if (origin === "sideForm") {
                sale.errors = null;
                sale.addressErrors = {};
                sale.receiverErrors = {};
                sale.deliveryErrors = {};
                var originalSale = _.find(ctrl.sales, {
                  idImportacao: sale.idImportacao,
                });
                originalSale = _.assign(originalSale, sale);
                $scope.$broadcast("validation:success");
              }
              return;
            }
            // ERRORS:
            sale.errors = getValidationErrors(errorsObj);
            sale.addressErrors = getErrorsByGroup(sale.errors, "address");
            sale.receiverErrors = getErrorsByGroup(sale.errors, "receiver");
            sale.deliveryErrors = getErrorsByGroup(sale.errors, "delivery");
            if (origin === "sideForm") {
              $scope.$broadcast("validation:fail", sale);
            }
          });
        })
        .catch(function (err) {
          ctrl.disableCreateBtn = false;
          _.forEach(sales, function (o) {
            o.showSpinner = false;
          });
          console.log("Sale validation error", err);
        });
    }

    var statusSale;
    IntegrationService.getOrderStatus(ctrl.provider.slug).then(
      function (data) {
        ctrl.showMenu = true;
        if (data.error) {
          console.log("Order status error:", data.error.message);
          return;
        }
        statusSale = data.selecionado;
      },
      function () {
        console.log("Order status error API");
      }
    );

    ctrl.openMenu = function (evt) {
      var position = $mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .withOffsetX("-25px")
        .addPanelPosition(
          $mdPanel.xPosition.ALIGN_START,
          $mdPanel.yPosition.BELOW
        );
      var config = {
        attachTo: angular.element(document.body),
        controller: "FilterMenuCtrl",
        controllerAs: "ctrl",
        panelClass: "filter-menu",
        position: position,
        locals: {
          statuses: angular.copy(statuses),
          saleStatus: statusSale,
          provider: ctrl.provider,
          parent: ctrl,
        },
        targetEvent: evt,
        template: require("./filter-menu/filter-menu.html"),
        clickOutsideToClose: true,
        escapeToClose: true,
        onCloseSuccess: function (panelRef, filterObj) {
          if (!filterObj.submited) {
            return;
          }
          if (ctrl.selected.length > 0) {
            showConfirm().then(function () {
              ctrl.selected.length = 0;
              setStatuses(filterObj.statuses);
              statuses = getStatuses();
              ctrl.getSales();
            });
          } else {
            ctrl.pagina = 1;
            setStatuses(filterObj.statuses);
            statuses = getStatuses();
            ctrl.getSales();
          }
        },
      };

      $mdPanel.open(config).then(setBackdropHeight);
    };

    ctrl.shippingFilter = [];
    // OPEN SHIPPING FILTER
    ctrl.openShipping = function (evt) {
      var position = $mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .withOffsetX("-25px")
        .addPanelPosition(
          $mdPanel.xPosition.ALIGN_START,
          $mdPanel.yPosition.BELOW
        );

      var config = {
        attachTo: angular.element(document.body),
        controller: "FilterShippingCtrl",
        controllerAs: "ctrl",
        panelClass: "filter-shipping",
        position: position,
        locals: {
          currentFilter: ctrl.shippingFilter,
        },
        targetEvent: evt,
        template: require("./filter-shipping/filter-shipping.html"),
        clickOutsideToClose: true,
        escapeToClose: true,
        onCloseSuccess: function (panelRef, filterObj) {
          if (filterObj.action == "submit") {
            ctrl.filterShipping(filterObj.filter);
            ctrl.shippingFilter = filterObj.filter;
          }
        },
      };

      $mdPanel.open(config).then(setBackdropHeight);
    };

    ctrl.hasStatusOpts = function () {
      var settings = _.find(PROVIDERS, { slug: ctrl.provider.slug });
      return settings.config && settings.config.status;
    };

    ctrl.actions = {
      delivery: null,
      insurance: null,
    };

    ctrl.verificarIntegracoesDisponiveis = function () {
      return ctrl.provider.allowMultiplesVolumes;
    };

    ctrl.showBulkActions = function (evt) {
      var position = $mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .withOffsetX("-20px")
        .addPanelPosition(
          $mdPanel.xPosition.ALIGN_START,
          $mdPanel.yPosition.BELOW
        );

      var config = {
        attachTo: angular.element(document.body),
        controller: "BulkActionsCtrl",
        controllerAs: "ctrl",
        panelClass: "bulk-actions-menu",
        position: position,
        bindToController: true,
        targetEvent: evt,
        template: require("./bulk-actions/bulk-actions.html"),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          actions: ctrl.actions,
        },
      };
      $mdPanel.open(config).then(setBackdropHeight);
    };

    $scope.$watch("$ctrl.actions.delivery", function (data) {
      if (!data) {
        return;
      }
      _.forEach(ctrl.selected, function (sale) {
        if (!sale.formaEnvio) {
          sale.formaEnvio = {
            codigo: data.code,
            nomeExibicao: data.displayName,
          };
        } else {
          sale.formaEnvio.codigo = data.code;
          sale.formaEnvio.nomeExibicao = data.displayName;
        }
      });
      validate(ctrl.selected);
    });

    $scope.$watch("$ctrl.actions.insurance", function (data) {
      if (!data) {
        return;
      }
      _.forEach(ctrl.selected, function (sale) {
        if (!sale.formaEnvio) {
          sale.formaEnvio = {
            valorDeclarado: data.insurance,
          };
        } else {
          sale.formaEnvio.valorDeclarado = data.insurance;
        }
      });
      validate(ctrl.selected);
    });

    $scope.$watch("$ctrl.actions.document", function (data) {
      if (!data) {
        return;
      }
      _.forEach(ctrl.selected, function (sale) {
        sale.tipoDocumentoOrigem = data.document;
      });
      validate(ctrl.selected);
    });

    ctrl.showDescriptionPanel = function (evt, sale) {
      var offset = $(evt.target).parent().parent().offset();
      ctrl.detailedSale = angular.copy(sale);
      ctrl.showDescPanel = true;
      ctrl.descPanelPositionLeft = offset.left - 10; // wrapper padding = 10
      ctrl.descPanelPositionTop = offset.top;
    };

    ctrl.showErrorsPanel = function (evt, sale) {
      var offset = $(evt.target).offset();
      ctrl.saleWithErrors = angular.copy(sale);
      ctrl.displayErrorsPanel = true;
      ctrl.descErrorsPanelPositionTop = offset.top;
      ctrl.descErrorsPanelPositionLeft = offset.left - 400 + 20; // panel size + icon size
    };

    ctrl.updateSale = function (event) {
      validate(event.sale, "sideForm");
    };

    function createOrderSuccess() {
      var currentStatus = "EM_ANDAMENTO";
      var isCurrentStatusChecked = _.find(statuses, function (status) {
        return status.name === currentStatus;
      }).isChecked;
      _.forEach(ctrl.selected, function (sale) {
        sale.status = currentStatus;
        sale.showOkIcon = false;
        sale.isSelected = false;
        if (!isCurrentStatusChecked) {
          sale.isHidden = true;
          ctrl.total--;
          _.remove(ctrl.sales, function (s) {
            return s.idImportacao === sale.idImportacao;
          });
        }
      });
      Pedido.getPedidoAsync(true);
      showSuccessToast();
      ctrl.isCreatingOrders = false;
      ctrl.selected.length = 0;
      ctrl.disableOkBtn = false;
      ctrl.disableCreateBtn = false;
    }

    function createOrderFail(err) {
      ctrl.isCreatingOrders = false;
      ctrl.disableCreateBtn = false;
      var msg = err.data && err.data.error && err.data.error.message;
      ctrl.errorMessage = msg || "Ocorreu um erro, tente novamente.";

      var ids = [];

      for (var i = 0; i < err.data.length; i++) {
        if(err.data[i].idImportacao) {
          ids.push(err.data[i].idImportacao);
        }
      }

      var items = document.querySelectorAll('.md-body tr');

      for(var i = 0; i<items.length; i++) {
        if(ids.includes(items[i].dataset.id)) {
          items[i].classList.add('error-importacao');
        }
      }

      $mdToast.show($mdToast.simple()
      .textContent('As encomendas em vermelho já foram importadas')
      .position("top right")
      .action("x")
      .hideDelay(5000));
    }

    function _createOrders(packages, currentOrderId) {
      return IntegrationService.createOrder(ctrl.provider.slug, {
        id: currentOrderId || null,
        encomendas: packages,
      })
        .then(createOrderSuccess)
        .catch(createOrderFail);
    }

    ctrl.createOrders = function () {
      if (ctrl.isCreatingOrders) {
        return;
      }

      var salesWithErrors = _.filter(ctrl.selected, "errors");
      if (salesWithErrors.length > 0) {
        showErrorToast();
        return;
      }
      ctrl.isCreatingOrders = true;
      ctrl.disableCreateBtn = true;
      var packages = PackageParser.parse(ctrl.selected);
      Pedido.getPedidoAsync()
        .then(function (data) {
          var currentOrder = data;
          return _createOrders(packages, currentOrder.id);
        })
        .catch(function (err) {
          if (err.status === 404) {
            return _createOrders(packages);
          }
          ctrl.disableOkBtn = true;
          ctrl.isCreatingOrders = false;
          ctrl.disableCreateBtn = false;
          console.log("Error: create orders");
        });
    };

    function showOptions(sale) {
      sale.isSelected = _.includes(ctrl.selected, sale);
    }

    ctrl.onRowSelect = function (sale) {
      sale.inputMvReadonly = true;
      showOptions(sale);
      if (!sale.errors && !isMultipleChecked && !sale.showOkIcon) {
        sale.showSpinner = true;
        validate(sale);
      }
    };

    ctrl.onMultiple = function (checked) {
      isMultipleChecked = checked;
      var sales = _.reject(_.filter(ctrl.sales, { status: "NOVO" }), "errors");
      if (isMultipleChecked && sales.length > 0) {
        validate(sales);
      }
    };

    ctrl.onRowDeselect = function (sale) {
      showOptions(sale);
      sale.inputMvReadonly = false;
    };

    ctrl.toggleRight = function (event, sale) {
      event.stopPropagation();
      ctrl.saleToEdit = angular.copy(sale);
      $mdSidenav("right")
        .toggle()
        .then(function () {
          ctrl.isOpen = true;
        });
    };

    ctrl.filterShipping = function (shipping) {
      var index = shipping.indexOf("notFound");
      if (index !== -1) {
        shipping[index] = null;
      }

      var pattern = shipping;
      ctrl.sales = ctrl.salesOriginal;

      if (pattern.length === 0) {
        ctrl.sales = ctrl.salesOriginal;

        return;
      }

      ctrl.sales = _.filter(ctrl.sales, (element) => {
        return pattern.includes(element.formaEnvio.codigo);
      });
    };

    $scope.$watch("$ctrl.datepicker.date", function (newDate) {
      ctrl.startDate = newDate.startDate;
      ctrl.endDate = newDate.endDate;
      if (ctrl.selected.length > 0) {
        showConfirm().then(function () {
          ctrl.selected.length = 0;
          ctrl.getSales();
        });
      } else {
        ctrl.getSales();
      }
    });
  }

  angular.module("mandaeApp").controller("ImportSalesCtrl", ImportSalesCtrl);
})();
